import React from 'react';
import ThermometerLegend from './ThermometerLegend';
import ThermometerSegments from './ThermometerSegments';
import { formatNumber } from '../../../common/utils';
var Thermometer = function (_a) {
    var valueLabelPairs = _a.valueLabelPairs, _b = _a.tooltipMode, tooltipMode = _b === void 0 ? 'per-segment' : _b, dataType = _a.dataType;
    var values = valueLabelPairs.map(function (pair) { return pair.value; });
    var total = values.reduce(function (a, b) { return a + b; });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'thermometer__totalLabel' }, formatNumber(total)),
        React.createElement(ThermometerSegments, { valueLabelPairs: valueLabelPairs, tooltipMode: tooltipMode }),
        React.createElement(ThermometerLegend, { valueLabelPairs: valueLabelPairs, dataType: dataType })));
};
export default Thermometer;
//# sourceMappingURL=Thermometer.js.map